import { ChannelType } from '@faceup/utils'
import { useContext } from 'react'
import { type FragmentType, getFragmentData, graphql } from '../../../../../__generated__'
import { LayoutContext } from '../../../../../Contexts/LayoutContext'
import { useInstitution } from '../../../../../hooks/useInstitution'
import { SimpleHeaderContent } from '../../../../Header/SimpleHeaderContent'
import { PartnerInstitutionLogo } from './PartnerInstitutionLogo'

const fragments = {
  HeaderSimple_reportSource: graphql(`
    fragment HeaderSimple_reportSource on PublicReportSource {
      id
      languages
      sourceType
      defaultLanguage
      ...PartnerInstitutionLogo_reportSource
    }
  `),
}

type HeaderSimpleProps = {
  reportSource: FragmentType<typeof fragments.HeaderSimple_reportSource>
  isHiddenBackButton?: boolean
}

export const HeaderSimple = ({
  reportSource: _reportSource,
  isHiddenBackButton: _isHiddenBackButton,
}: HeaderSimpleProps) => {
  const reportSource = getFragmentData(fragments.HeaderSimple_reportSource, _reportSource)
  const isHiddenBackButton =
    _isHiddenBackButton ?? reportSource.sourceType === ChannelType.AutomatedHotline
  const { client } = useContext(LayoutContext)
  const institutionContext = useInstitution()
  const isApp = client === 'app'
  const homepageLinkCallback = institutionContext?.homepage ?? (routes => routes.home())

  return (
    <SimpleHeaderContent
      isApp={isApp}
      isHiddenBackButton={isHiddenBackButton}
      homepageLinkCallback={homepageLinkCallback}
      logoSlot={<PartnerInstitutionLogo reportSource={reportSource} />}
      languages={reportSource.languages ?? []}
      defaultLanguage={reportSource.defaultLanguage}
    />
  )
}
